<script setup lang="ts">
  import { ProductShortCard, ScanEpc, IncorrectEpc } from "../../components";

  const { productId, step } = defineProps<{ productId: string; step: string }>();
  const emit = defineEmits<{ "click:back": [value: void]; "click:ok": [value: void] }>();
</script>

<template>
  <div class="scan-epc-with-product" data-testid="scan-epc-with-product">
    <ProductShortCard :productId="productId" @click:back="emit('click:back')" />
    <div>
      <ScanEpc v-if="step === 'start'" />
      <IncorrectEpc v-if="step === 'error'" @click:back="emit('click:back')" @click:btn="emit('click:ok')">
        <slot />
      </IncorrectEpc>
    </div>
  </div>
</template>

<style scoped>
  .scan-epc-with-product {
    display: flex;
    flex-direction: column;
    flex: 1;
    background-color: var(--sf-base-background-card);
    overflow: hidden;
  }
</style>
